import { Check, Link } from 'lucide-react'

import { cn } from '@/lib/utils'

const evidenceClassName = 'absolute right-0 flex w-20 items-center justify-between rounded-md border border-border bg-card px-2 py-1 text-[10px] font-medium text-muted-foreground opacity-0 shadow-sm translate-x-2 animate-[listing-import-evidence_3.2s_ease-in-out_infinite] motion-reduce:animate-none motion-reduce:translate-x-0 motion-reduce:opacity-100'

export function ListingImportBlueprint({ activityLabel = 'Reading source listing…' }) {
  return (
    <div
      className="relative h-44 w-56 max-w-full"
      role="img"
      aria-label="Property blueprint scanning Price, Images, and EPC evidence from the source listing"
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 180 140"
        className="absolute inset-x-6 bottom-2 top-7 h-36 w-44 fill-none text-border/70"
      >
        <path
          className="stroke-current [stroke-width:1]"
          d="M10 10V130M30 10V130M50 10V130M70 10V130M90 10V130M110 10V130M130 10V130M150 10V130M170 10V130M10 10H170M10 30H170M10 50H170M10 70H170M10 90H170M10 110H170M10 130H170"
        />
      </svg>

      <div className="absolute left-0 top-0 z-20 flex items-center gap-1.5 whitespace-nowrap rounded-full border border-border bg-card px-2.5 py-1 text-[10px] text-muted-foreground shadow-sm">
        <Link className="h-3 w-3 text-primary" aria-hidden="true" />
        {activityLabel}
      </div>

      <svg
        aria-hidden="true"
        viewBox="0 0 120 105"
        className="absolute left-10 top-11 h-28 w-28 fill-none text-primary"
      >
        <path
          className="animate-[listing-import-blueprint-draw_3.2s_ease-in-out_infinite] stroke-current [stroke-dasharray:270] [stroke-dashoffset:270] [stroke-linecap:round] [stroke-linejoin:round] [stroke-width:3] motion-reduce:animate-none motion-reduce:[stroke-dashoffset:0]"
          d="M8 48 60 8l52 40M20 42v55h80V42M44 97V65h32v32M29 55h17v17H29m45-17h17v17H74"
        />
      </svg>

      <span
        aria-hidden="true"
        className="absolute left-8 right-8 top-12 z-10 h-0.5 bg-primary shadow-sm animate-[listing-import-scan_2.4s_ease-in-out_infinite_alternate] motion-reduce:hidden"
      />

      <div className={cn(evidenceClassName, 'top-10 [animation-delay:400ms]')}>
        Price
        <Check className="h-3 w-3 text-primary" aria-hidden="true" />
      </div>
      <div className={cn(evidenceClassName, 'top-[4.75rem] [animation-delay:750ms]')}>
        Images
        <Check className="h-3 w-3 text-primary" aria-hidden="true" />
      </div>
      <div className={cn(evidenceClassName, 'top-28 [animation-delay:1100ms]')}>
        EPC
        <Check className="h-3 w-3 text-primary" aria-hidden="true" />
      </div>
    </div>
  )
}
